module.exports = __webpack_public_path__ + "img/ps-empleo.2605db63.jpg";